const StatCard = ({ title, value, subtitle, icon, trend, color = "blue" }) => {
  const renderSubtitle = (text, numberColor = "#16A34A") => {
    if (typeof text !== "string") return text;
    const parts = text.split(/(\+?\d+(?:\.\d+)?%?)/g);
    return parts.map((part, i) => {
      const m = part.match(/^(\+?\d+(?:\.\d+)?)(%?)$/);
      if (m) {
        return (
          <span key={i} style={{ color: numberColor }}>
            {m[1]}
            {m[2]}
          </span>
        );
      }
      return part;
    });
  };

  const isActivePositions = title === "Active Positions";
  const subtitleNumberColor = isActivePositions ? "#2563EB" : "#16A34A";

  const colorClasses = {
    blue: "icon-blue",
    green: "icon-green",
    orange: "icon-orange",
    red: "icon-red",
    purple: "icon-purple",
  };

  const trendClasses = {
    blue: "trend-positive",
    green: "trend-positive",
    orange: "trend-negative",
    red: "trend-negative",
    purple: "trend-positive",
  };

  return (
    <div className="stat-card">
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <div className="stat-title">{title}</div>
          <div className="d-flex align-items-baseline gap-2">
            <div className="stat-value">{value}</div>
            {trend && (
              <span className={`small fw-medium ${trendClasses[color]}`}>
                {trend}
              </span>
            )}
          </div>
          {/* {subtitle && <div className="stat-subtitle">{renderSubtitle(subtitle, subtitleNumberColor)}</div>} */}
        </div>
        {icon && (
          <div className={`stat-icon ${colorClasses[color]}`}>{icon}</div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
